import { routes } from "config/paths";

const CUSTOMER_ANALYTICS_ROUTES = new Set<string>([
	routes.accountName.maps.root,
	routes.accountName.maps.mapId.mapName.root,
	routes.accountName.data.root,
	routes.accountName.data.datasetId.datasetName.root,
]);

export const isCustomerAnalyticsRoute = (pathname: string): boolean =>
	CUSTOMER_ANALYTICS_ROUTES.has(pathname);
